import { Button, Col, DatePicker, Form, Input, Row, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { UploadOutlined } from '@ant-design/icons'
import { HostelFeePaymentAPI, HostelFeeReuploadAPI } from '../../../AllAPI/StudentAPI'
import axios from 'axios'
import QRCodeImg from '../../../Assets/UpdatedQrCode.jpeg'
import { validateImageUpload } from '../../../Validation/FileValidation'


const { Option } = Select


const HostelFeePayment = () => {
  const navigate = useNavigate()

  //---------------------------------Disabled back button-------------------------------
  useEffect(() => {
    window.history.pushState(null, null, window.location.href)

    const handleBackButton = (event) => {
      event.preventDefault()
      window.history.forward()
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [])

  const location = useLocation()
  const formDataFromStorage = JSON.parse(
    sessionStorage.getItem('studentData') || '{}',
  )
  console.log(formDataFromStorage);

  const RejectReason = formDataFromStorage.reject_reason;
  const RegId = formDataFromStorage.reg_id
  const Status = formDataFromStorage.status
  const BranchId = formDataFromStorage.branch_id
  const BoardingYear = formDataFromStorage.year
  // const HostelFeeAmount = formDataFromStorage.pay_hostel_fee
  const ConcessionFlag = formDataFromStorage.concession_flag
  // const HostelFee = formDataFromStorage.pay_hostel_fee;
  // const SecurityDeposit  = formDataFromStorage.security_deposit;
  // const TotalFee = HostelFee + SecurityDeposit;

  // const [payMode, setPayMode] = useState('')
  // // const [amount, setAmount] = useState(HostelFeeAmount)
 
  const HostelFee = Number(formDataFromStorage.hostel_fee || 0);
  const SecurityDeposit = Number(formDataFromStorage.security_deposit || 0);
  const TotalFee = Number(formDataFromStorage.pay_hostel_fee || 0);

  const [payMode, setPayMode] = useState('')
  const [amount, setAmount] = useState(0);
  const [taxId, setTaxId] = useState('')
  const [taxImg, setTaxImg] = useState(null)
  const [paymentDate, setPaymentDate] = useState('')

  useEffect(() => {
  setAmount(TotalFee);
}, [TotalFee]);

  const handleImageUpload = (info) => {
    const file = info.fileList?.[0]?.originFileObj

    if (file) {
      setTaxImg(file) // correct File object
    } else {
      toast.warn('Upload Image')
    }
  }

  const handleSubmit = async () => {
    // Validation
    if (!payMode) {
      toast.warn('Please select a payment mode')
      return
    }

    if (payMode === '1' || payMode === '2') {
      if (!taxId.trim()) {
        toast.warn(
          payMode === '2'
            ? 'Please enter UPI Transaction ID'
            : 'Please enter Receipt ID',
        )
        return
      }

      if (!paymentDate) {
        toast.warn('Please select a payment date')
        return
      }

      if (!taxImg) {
        toast.warn('Please upload receipt image')
        return
      }
    }

    const fd = new FormData()
    fd.append('hostel_pay_mode', payMode)
    fd.append('hostel_pay_amount', amount)
    fd.append('hostel_tax_id', taxId)
    // fd.append('hostel_pay_date', paymentDate?.format('YYYY-MM-DD'))
    fd.append(
      'hostel_pay_date',
      paymentDate && typeof paymentDate.format === 'function'
        ? paymentDate.format('YYYY-MM-DD')
        : '',
    )
    fd.append('hostel_tax_image', taxImg)
    fd.append('hostel_payment_year', new Date().getFullYear())
    fd.append('hostelPay_approval', 1) //pending==1, but not approved by admin
    fd.append('year', BoardingYear)

    try {
      // const res = await axios.put(`${HostelFeePaymentAPI}/${RegId}`, fd, {
      //   headers: { 'Content-Type': 'multipart/form-data' },
      // })

      const api =
        Status == 3 ? HostelFeeReuploadAPI : HostelFeePaymentAPI;

      const res = await axios.put(`${api}/${RegId}`,fd,{
        headers: {
            "Content-Type": "multipart/form-data",
        },
      }
      );

      if (res.data == 'ERROR') {
        toast.warn('Error Occurred!!')
      } else if (res.data == 'SAVED') {
        navigate('/student/login')
        toast.success('Payment Successful, Waiting for Admin Approval!')
      }
    } catch (err) {
      toast.error('Error while submitting payment')
    }
  }

  const handleReset = () => {
    setPayMode('')
    // setAmount(HostelFeeAmount)
     setAmount(TotalFee)
    setTaxId('')
    setTaxImg(null)
    setPaymentDate('')
  }

  const MAX_SIZE = 2 * 1024 * 1024 // 2MB

  const beforeUploadReceipt = (file) => {
    const isValidType =
      file.type === 'image/png' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/jpg'

    if (!isValidType) {
      toast.error('Only PNG and JPEG files are allowed')
      return Upload.LIST_IGNORE
    }

    const isValidSize = file.size <= MAX_SIZE

    if (!isValidSize) {
      toast.error('Image must be smaller than 2MB')
      return Upload.LIST_IGNORE
    }

    return false // prevent auto upload (keep file in UI only)
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Hostel Fee Payment</h2>
          </div>

          {/* {Status == '3' && (
            <div className="row">
              <span style={{ color: 'red' }}>
                ( Note: Your hostel fee payment has been rejected by the admin.
                Please make the payment again. )
              </span>
            </div>
          )} */}

          {Status == "3" && (
            <div
              style={{
                background: "#fff2f0",
                border: "1px solid #ff4d4f",
                borderRadius: "8px",
                padding: "15px",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ color: "#cf1322" }}>
                Hostel Fee Rejected
              </h5>

              <p>
                <strong>Reason :</strong> {RejectReason}
              </p>

              <p>Please upload the payment details again.</p>
            </div>
          )}

          <div className="row">
            <Row
              gutter={[16, 0]}
              className="my-2 p-2 rounded border"
              style={{ backgroundColor: '#f2f7fdff' }}
            >
              <Col xs={24} sm={8}></Col>
              <Col xs={24} sm={8} className="pt-4">
                <Form.Item
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  label="Payment Mode"
                  rules={[{ required: true, message: 'Select payment mode' }]}
                >
                  <Select
                    placeholder="Select payment mode"
                    size="large"
                    value={payMode}
                    onChange={(value) => setPayMode(value)}
                  >
                    {/* <Option value="1">Cash</Option> */}
                    <Option value="2">UPI</Option>
                    <Option value="3">Online</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}></Col>

              <Col xs={24} className="text-center">
                {ConcessionFlag == 1 && (
                  <span style={{ color: 'red' }}>
                    {' '}
                    (Note : Your fee concession has been successfully applied.){' '}
                  </span>
                )}
              </Col>

              <Col xs={24} sm={8}></Col>
              <Col xs={24} sm={8} className="py-2 text-center">
                {payMode == 2 && (
                  <>
                    <img
                      src={QRCodeImg}
                      alt="QR Code"
                      className="rounded shadow"
                      style={{
                        width: '200px',
                        height: '200px',
                        border: '1px solid #d1d1d1ff',
                      }}
                    />{' '}
                    <br />
                    <span>QR Code for payment</span>
                  </>
                )}
              </Col>
              <Col xs={24} sm={8}></Col>
            </Row>

            {(payMode === '1' || payMode === '2' || payMode === '3') && (
              <Row
                gutter={[16, 0]}
                className="my-2 p-2 rounded border"
                style={{ backgroundColor: '#f2f7fdff' }}
              >

              <Col xs={24}>
                <div
                  style={{
                    background: "#fff",
                    border: "1px solid #d9d9d9",
                    borderRadius: "8px",
                    padding: "15px",
                    marginBottom: "20px",
                  }}
                >
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <div
                      style={{
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        borderRadius: "6px",
                        padding: "15px",
                      }}
                    >
                      <h5>Hostel Fee</h5>
                      <h4>₹ {HostelFee}</h4>
                    </div>
                  </Col>

                  <Col xs={24} md={8}>
                    <div
                      style={{
                        textAlign: "center",
                        border: "1px solid #e8e8e8",
                        borderRadius: "6px",
                        padding: "15px",
                      }}
                    >
                      <h5>Security Deposit</h5>
                      <h4>₹ {SecurityDeposit}</h4>
                    </div>
                  </Col>

                  <Col xs={24} md={8}>
                    <div
                      style={{
                        textAlign: "center",
                        border: "2px solid #1677ff",
                        borderRadius: "6px",
                        background: "#f0f8ff",
                        padding: "15px",
                      }}
                    >
                      <h5>Total Fee</h5>
                      <h3 style={{ color: "#1677ff" }}>
                        ₹ {TotalFee}
                      </h3>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

                {payMode === '1' && (
                  <>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Amount"
                      >
                        <Input readOnly size="large" value={amount} />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Receipt ID"
                        rules={[
                          { required: true, message: 'Enter receipt ID' },
                        ]}
                      >
                        <Input
                          placeholder="Enter receipt ID"
                          size="large"
                          value={taxId}
                          onChange={(e) => setTaxId(e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Payment Date"
                        rules={[
                          { required: true, message: 'Select payment date' },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          onChange={(date) => setPaymentDate(date)}
                          size="large"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item noStyle>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                          Upload Receipt Image &nbsp;
                        </div>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          rules={[{ required: true }]}
                        >
                          <Upload
  beforeUpload={validateImageUpload}
                            beforeUpload={() => false}
                            onChange={handleImageUpload}
                            listType="picture"
                            maxCount={1}
                            style={{ width: '100%' }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              size="large"
                              style={{ width: '100%' }}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    {/* ====== Buttons ====== */}
                    <Col xs={24}>
                      <Row justify="center" gutter={16}>
                        <Col>
                          <Button onClick={handleReset}>Back</Button>
                        </Col>

                        <Col>
                          <Button
                            className="addButton"
                            htmlType="submit"
                            onClick={handleSubmit}
                          >
                            Proceed
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                {payMode === '2' && (
                  <>
                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Amount"
                      >
                        <Input readOnly size="large" value={amount} />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item noStyle>
                        <div
                          style={{
                            marginBottom: 12,
                            marginTop: 7,
                            fontWeight: 500,
                          }}
                        >
                          UPI Transaction ID &nbsp;
                        </div>
                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          rules={[
                            {
                              required: true,
                              message: 'Enter UPI transaction ID',
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter UPI Txn ID"
                            size="large"
                            value={taxId}
                            onChange={(e) => setTaxId(e.target.value)}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Payment Date"
                        rules={[
                          { required: true, message: 'Select payment date' },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          onChange={(date) => setPaymentDate(date)}
                          size="large"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={8}>
                      <Form.Item noStyle>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                          Upload Receipt Image &nbsp;
                        </div>

                        <Form.Item
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          rules={[
                            {
                              required: true,
                              message: 'Receipt image is required',
                            },
                          ]}
                        >
                          <Upload
  beforeUpload={validateImageUpload}
                            beforeUpload={beforeUploadReceipt}
                            onChange={handleImageUpload}
                            listType="picture"
                            maxCount={1}
                            accept=".jpg,.jpeg,.png"
                            style={{ width: '100%' }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              size="large"
                              style={{ width: '100%' }}
                            >
                              Upload
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    {/* ====== Buttons ====== */}
                    <Col xs={24}>
                      <Row justify="center" gutter={16}>
                        <Col>
                          <Button onClick={handleReset}>Back</Button>
                        </Col>

                        <Col>
                          <Button
                            type="primary"
                            htmlType="submit"
                            onClick={handleSubmit}
                          >
                            Proceed
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                {payMode === '3' && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      gap: '20px',
                      marginTop: '20px',
                      width: '100%',
                    }}
                  >
                    {/* ====== Buttons ====== */}
                    <Col xs={24}>
                      <Row justify="center" gutter={16}>
                        <Col>
                          <Button onClick={handleReset}>Back</Button>
                        </Col>

                        <Col>
                          <Button
                            type="primary"
                            style={{ backgroundColor: '#1677ff' }}
                            onClick={() =>
                              toast.info('Redirecting to online payment...')
                            }
                          >
                            Pay Now
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </Row>
            )}
          </div>

          <div className="col-12 col-md-2"></div>
        </div>
      </div>
    </div>
  )
}

export default HostelFeePayment
